import { call, put, takeLatest } from "redux-saga/effects";
import { mucThuNhapHocSinhVienApi } from "../../../api/chung-tu/mucThuNhapHocSinhVienApi";
import { IMucThuNhapHocSinhVienSelectRequest } from "../../../model/request/chung-tu-nhap-hoc/IMucThuNhapHocSinhVienSelectRequest";
import { IMucThuNhapHocSinhVienViewModel } from "../../../model/respone/chung-tu-nhap-hoc/IMucThuNhapHocSinhVienViewModel";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eThuPhiNhapHocActionIds,
  IThuPhiNhapHocActionTypes,
} from "../../action-types/thu-phi-nhap-hoc/IThuPhiNhapHocActionTypes";
import { rootActions } from "../../actions/rootActions";
import { IBienLaiThuCreateRequest } from "../../../model/request/bien-lai/IBienLaiThuCreateRequest";
import { IBienLaiThuUpdateRequest } from "../../../model/request/bien-lai/IBienLaiThuUpdateRequest";
import { bienLaiThuApi } from "../../../api/bien-lai/bienLaiThuApi";
import { sinhVienApi } from "../../../api/category/sinhVienApi";
import { IStuHoSoSinhVienViewModel } from "../../../model/respone/category/IStuHoSoSinhVienViewModel";

export function* thuPhiNhapHocSaga(): any {
  yield takeLatest(eThuPhiNhapHocActionIds.LOAD_MUC_THU_START, loadWorker);
  yield takeLatest(eThuPhiNhapHocActionIds.ADD_NEW_TAB_BY_ID, addNewTabWorker);
  yield takeLatest(
    eThuPhiNhapHocActionIds.CREATE_BIENLAITHU_START,
    createBienLaiWorker
  );
  yield takeLatest(
    eThuPhiNhapHocActionIds.LOAD_EDIT_BIENLAI_START,
    loadEditBienLaiWorker
  );
  yield takeLatest(
    eThuPhiNhapHocActionIds.UPDATE_BIENLAITHU_START,
    updateBienLaiWorker
  );
  yield takeLatest(
    eThuPhiNhapHocActionIds.PREVIEW_BIENLAITHU_START,
    previewBienLaiWorker
  );
}

function* loadEditBienLaiWorker(action: IThuPhiNhapHocActionTypes): any {
  const { id_bien_lai, request } = action.payload as {
    id_bien_lai: number;
    request: IMucThuNhapHocSinhVienSelectRequest;
  };
  // Nạp lại mục thu (đảm bảo có để map khoản), rồi nạp chi tiết biên lai cần sửa.
  const resMuc: IBaseRespone = yield call(
    mucThuNhapHocSinhVienApi.SelectBySinhVien,
    request
  );
  if (resMuc.is_success) {
    yield put(
      rootActions.thuPhi.thuPhiNhapHoc.LOAD_MUC_THU_SUCCESS({
        request,
        data: resMuc.data,
      })
    );
  }
  const resBl: IBaseRespone = yield call(
    bienLaiThuApi.SelectByIDBienLai,
    id_bien_lai
  );
  if (resBl.is_success) {
    yield put(
      rootActions.thuPhi.thuPhiNhapHoc.LOAD_EDIT_BIENLAI_SUCCESS({
        request,
        data: resBl.data,
      })
    );
  } else {
    yield put(
      rootActions.thuPhi.thuPhiNhapHoc.LOAD_EDIT_BIENLAI_ERROR({
        request,
        data: resBl.message ?? "Có lỗi",
      })
    );
  }
}

function* updateBienLaiWorker(action: IThuPhiNhapHocActionTypes): any {
  const request = action.payload as IBienLaiThuUpdateRequest;
  const res: IBaseRespone = yield call(bienLaiThuApi.Update, request);
  if (res.is_success) {
    const data: number = res.data;
    yield put(
      rootActions.thuPhi.thuPhiNhapHoc.UPDATE_BIENLAITHU_SUCCESS({
        request: {
          ...request,
          nam_nhap_hoc: +request.nam_hoc.split("-")[0] | 0,
        },
        data,
      })
    );
    yield put(rootActions.bienLai.bienLaiViewChiTiet.LOAD_START(data));
    yield put(
      rootActions.bienLai.bienLaiView.LOAD_START({
        hoc_ky: request.hoc_ky,
        nam_hoc: request.nam_hoc,
        id_sv: request.id_sv,
      })
    );
    yield put(
      rootActions.bienLai.bienLaiView.LOAD_START({
        hoc_ky: 0,
        nam_hoc: "",
        id_sv: request.id_sv,
      })
    );
  } else {
    yield put(
      rootActions.thuPhi.thuPhiNhapHoc.UPDATE_BIENLAITHU_ERROR({
        request: {
          ...request,
          nam_nhap_hoc: +request.nam_hoc.split("-")[0] | 0,
        },
        data: res.message ?? "Có lỗi",
      })
    );
  }
}

function* loadWorker(action: IThuPhiNhapHocActionTypes): any {
  const request = action.payload as IMucThuNhapHocSinhVienSelectRequest;
  const res: IBaseRespone = yield call(
    mucThuNhapHocSinhVienApi.SelectBySinhVien,
    request
  );
  if (res.is_success) {
    const data: IMucThuNhapHocSinhVienViewModel[] = res.data;
    yield put(
      rootActions.thuPhi.thuPhiNhapHoc.LOAD_MUC_THU_SUCCESS({
        request: request,
        data,
      })
    );
  } else {
    yield put(
      rootActions.thuPhi.thuPhiNhapHoc.LOAD_MUC_THU_ERROR({
        request: request,
        data: res.message ?? "Có lỗi",
      })
    );
  }
}
function* addNewTabWorker(action: IThuPhiNhapHocActionTypes): any {
  const request = action.payload as string;
  const res: IBaseRespone = yield call(sinhVienApi.SelectById, request);
  if (res.is_success) {
    const data: IStuHoSoSinhVienViewModel = res.data;
    yield put(rootActions.thuPhi.thuPhiNhapHoc.ADD_NEW_TAB(data));
  } else {
    yield put(
      rootActions.thuPhi.thuPhiNhapHoc.ADD_NEW_TAB_BY_ID_ERROR(
        res.message ?? "Có lỗi"
      )
    );
  }
}

function* createBienLaiWorker(action: IThuPhiNhapHocActionTypes): any {
  const request = action.payload as IBienLaiThuCreateRequest;
  const res: IBaseRespone = yield call(bienLaiThuApi.Create, request);
  if (res.is_success) {
    const data: number = res.data;
    yield put(
      rootActions.thuPhi.thuPhiNhapHoc.CREATE_BIENLAITHU_SUCCESS({
        request: {
          ...request,
          nam_nhap_hoc: +request.nam_hoc.split("-")[0] | 0,
        },
        data,
      })
    );
    // yield put(
    //   rootActions.mucThu.mucthuTamThu.LOAD_SO_TIEN_CON_LAI_LOAD_START(
    //     request.id_sv
    //   )
    // );
    yield put(rootActions.bienLai.bienLaiViewChiTiet.LOAD_START(data));
    yield put(
      rootActions.bienLai.bienLaiView.LOAD_START({
        hoc_ky: request.hoc_ky,
        nam_hoc: request.nam_hoc,
        id_sv: request.id_sv,
      })
    );
    // Làm mới luôn danh sách "Tất cả" (mọi học kỳ, mọi năm) để khớp biên lai vừa tạo
    yield put(
      rootActions.bienLai.bienLaiView.LOAD_START({
        hoc_ky: 0,
        nam_hoc: "",
        id_sv: request.id_sv,
      })
    );
  } else {
    yield put(
      rootActions.thuPhi.thuPhiNhapHoc.CREATE_BIENLAITHU_ERROR({
        request: {
          ...request,
          nam_nhap_hoc: +request.nam_hoc.split("-")[0] | 0,
        },
        data: res.message ?? "Có lỗi",
      })
    );
  }
}

function* previewBienLaiWorker(action: IThuPhiNhapHocActionTypes): any {
  const request = action.payload as IBienLaiThuCreateRequest;
  const res: IBaseRespone = yield call(bienLaiThuApi.Preview, request);
  if (res.is_success) {
    const data: string = res.data;
    yield put(
      rootActions.thuPhi.thuPhiNhapHoc.PREVIEW_BIENLAITHU_SUCCESS({
        request: {
          ...request,
          nam_nhap_hoc: +request.nam_hoc.split("-")[0] | 0,
        },
        data,
      })
    );
  } else {
    yield put(
      rootActions.thuPhi.thuPhiNhapHoc.PREVIEW_BIENLAITHU_ERROR({
        request: {
          ...request,
          nam_nhap_hoc: +request.nam_hoc.split("-")[0] | 0,
        },
        data: res.message ?? "Có lỗi",
      })
    );
  }
}
